import { render } from "./CustomRules.vue?vue&type=template&id=386d481c"
import script from "./CustomRules.vue?vue&type=script&lang=js"
export * from "./CustomRules.vue?vue&type=script&lang=js"

import "./CustomRules.vue?vue&type=style&index=0&id=386d481c&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__